import { HubAction } from './hub.action';
import { NotificationFacade } from '../../../../store/facade/notification.facade';

export class OrderEditStateChangedAction extends HubAction {
    /**
     *
     */
    constructor(private notificationFacade: NotificationFacade) {
        super('OrderEditStateChanged');
    }

    public action(user: string[], orderId: string): void {
        this.notificationFacade.updateOneOrder({
            id: 0,
            users: user,
            orderId: <number>(<unknown>orderId),
        });
    }
}
